import React from 'react'
import { connect } from 'react-redux'

import clsx from 'clsx'

import { AiOutlineArrowDown } from 'react-icons/ai'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { MesesContabilidadConstant } from 'constants/index'

import * as AuthService from 'services/auth.service'
import * as BloqueosPeriodosService from 'services/bloqueosPeriodo.service'

import * as auth from 'store/ducks/auth.duck'

import * as Modals from './Modals'

const AppSubHeader = props => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [mostrarCambioCompanialModal, setMostrarCambioCompanialModal] = React.useState(false)
  const [bloqueosPeriodo, setBloqueosPeriodo] = React.useState({
    mayorizados: [],
    bloqueosGlobales: []
  })

  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const clickCambiarCompania = React.useCallback(() => {
    setMostrarCambioCompanialModal(true)
  }, [])

  React.useEffect(() => {
    BloqueosPeriodosService.obtenerBloqueos()
      .then(({ data }) => {
        if (data) {
          setBloqueosPeriodo(data)
        }
      })
      .catch(() => {
        __zariContext.snack('error', 'No se pudo obtener información de los periodos')
        setIsSubmitting(false)
      })
  }, [__zariContext])

  const clickListarMeses = e => {
    e.preventDefault()

    e.currentTarget.parentNode.classList.toggle('open-contenido')
  }

  const clickCambioMes = React.useCallback(
    (e, data) => {
      e.preventDefault()

      setIsSubmitting(true)
      AuthService.cambiarMesTrabajo(data)
        .then(({ data: data2 }) => {
          props.setToken(data2.accessToken)
          window.location.href = '/'
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setIsSubmitting(false)
        })
    },
    [__zariContext, props]
  )

  return (
    <>
      <div className='app-subheader'>
        <div className='cner-fluid'>
          <div className='d-flex'>
            <div className='subheader-item subheader-comsed'>
              <button onClick={clickCambiarCompania}>
                <span>Compañia :</span>
                <span>{__adminContext.nombreCompania || 'Cargando ...'}</span>
              </button>
            </div>
            <div className='subheader-item subheader-periodo'>
              <p>
                {`${__adminContext.mesTrabajo ? MesesContabilidadConstant.__dictionary[__adminContext.mesTrabajo].nombreCorto : '--'}`} -{' '}
                {__adminContext.anioTrabajo}
              </p>
            </div>
            <div className='subheader-item subheader-meses'>
              <div className='btn-group'>
                {MesesContabilidadConstant.__array.map((x, k) => (
                  <button
                    className={clsx('boton-periodo-mes', `boton-periodo-mes-${x.id}`, {
                      'bg-warning': bloqueosPeriodo.mayorizados[parseInt(x.id)] === 1
                    })}
                    key={k}
                    onClick={e => clickCambioMes(e, { mesTrabajo: x.id })}
                    disabled={isSubmitting}
                  >
                    {x.id}
                    {bloqueosPeriodo.bloqueosGlobales[parseInt(x.id)] === 1 && <span style={{ fontSize: 8, verticalAlign: 'top' }}>B</span>}
                  </button>
                ))}
              </div>
            </div>
            <div className='subheader-item subheader-periodo-meses'>
              <p className='periodo-meses-nombre'>
                {`${__adminContext.mesTrabajo ? MesesContabilidadConstant.__dictionary[__adminContext.mesTrabajo].nombreCorto : '--'}`} -{' '}
                {__adminContext.anioTrabajo}
              </p>
              <button className='periodo-meses-boton' type='button' onClick={clickListarMeses}>
                <AiOutlineArrowDown />
              </button>
              <div className='periodo-meses-contenido'>
                {MesesContabilidadConstant.__array.map((x, k) => (
                  <a
                    key={k}
                    href='#!'
                    className={clsx('boton-periodo-mes', `boton-periodo-mes-${x.id}`, {
                      'bg-warning': bloqueosPeriodo.mayorizados[parseInt(x.id)] === 1
                    })}
                    onClick={e => clickCambioMes(e, { mesTrabajo: x.id })}
                    disabled={isSubmitting}
                  >
                    {`${x.nombre} - ${x.id}`}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {mostrarCambioCompanialModal && (
        <Modals.CompaniaHandlerModal handleClose={() => setMostrarCambioCompanialModal(false)} show={mostrarCambioCompanialModal} />
      )}
    </>
  )
}

export default connect(null, auth.actions)(AppSubHeader)
